<div class="register-entrance mat-body">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'Accept Entrance' | translate: ['tmc.transport.register.entrance.title', translationService.language]}}
    </h2>

    <div class="top-info">
      <app-transport-info-panel [carrier]="transport.carrier" [identifier]="transport.identifier"
        [driver]="transport.name" [scope]="transport.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">

      <div class="form-box">
        <h3>{{'Spur' | translate: ['tmc.transport.register.entrance.area-gate.title', translationService.language]}}</h3>
        <mat-form-field >
          <mat-select [(value)]="selectedAreaGate">
              <mat-option *ngFor="let gate of areaGates" [value]="gate">
                  {{ gate.name }}
              </mat-option>
          </mat-select>
      </mat-form-field>
      </div>
      
      <form #weighForm="ngForm" class="weigh-input-form" *ngIf="isWeighingActive()">
        <div class="form-box">
          <h3>{{'weigh transport' | translate: ['tmc.transport.register.entrance.weighing.title',
            translationService.language]}}</h3>
          <div class="flex-direction-row width-50 row-flex">
            <mat-form-field class="flex-grow-1">
              <input name="value" matInput [(ngModel)]="transport.weight" #ctrlValue="ngModel" type="number" min="0"
                placeholder="{{'weight' | translate: ['tmc.transport.register.entrance.weight', translationService.language]}}"
                [readonly]="false"
                [required]="cps.isRequired(clientParameters.P_VISITOVERVIEW_REGISTER_LEAVE_MINLENGHT_WEIGHT, false)"
                appPositiveInteger>
              <mat-error *ngIf="showValuePositiveIntegerError(ctrlValue)">
                {{'value must positive and Integer' | translate: ['tmc.weigh-transport-dialog.error.value-no-integer',
                translationService.language]}}
              </mat-error>
            </mat-form-field>
            <button mat-icon-button class="weighingButton" (click)="readWeight()" [hidden]="isAutoWeighingVisible()"
              [matTooltip]="'Weigh Transport' | translate: ['tmc.visit.overview.action.weighTransport', translationService.language]"
              *ngIf="cps.isEnabled(clientParameters.P_VISITS_WEIGHING_ENABLED, false)">
              <sc-icon iconClass="fa-balance-scale"></sc-icon>
            </button>
            <mat-form-field class="margin-left">
              <mat-label>
                {{'type' | translate: ['tmc.transport.register.entrance.weighingType',
                translationService.language]}}
              </mat-label>
              <mat-select name="type" [(ngModel)]="transport.weighingType" #ctrlType="ngModel"
                [required]="isWeighingTypeRequired()">
                <mat-option *ngFor="let o of typeOptions" value="{{o}}">
                  {{o | translate: ['tmc.transport.register.entrance.weighingType.' + o,
                  translationService.language]}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </form>

      <div class="form-box">
        <h3>{{'hints' | translate: ['tmc.transport.register.entrance.checks.title', translationService.language]}}
        </h3>
        <div class="checks-list">
          <ul *ngIf="checksExist(transport)">
            <li class="check" *ngFor="let check of transport.checks">
              <div class="icon">
                <i class="fa-light" [ngClass]="{
                    'fa-check color-ok': isOk(check), 
                    'fa-exclamation-triangle color-warn': isWarning(check), 
                    'fa-exclamation-circle color-error': isFailed(check),
                    'fa-info': isInfo(check)
                  }"></i>
              </div>
              <div class="message">
                {{check.nameDictionaryKey | translate: [check.nameDictionaryKey, translationService.language]}}
                <ng-container *ngIf="descriptionExists(check)">
                  -
                  {{check.descriptionDictionaryKey | translate: [check.descriptionDictionaryKey,
                  translationService.language]}}
                </ng-container>
              </div>
            </li>
          </ul>
          <span *ngIf="!checksExist(transport)">{{'Keine Hinweise' | translate:
            ['tmc.transport.register.entrance.checks.nochecks', translationService.language]}}</span>
        </div>
      </div>
    </div>
    <!-- wenn komponente als wizard genutzt wird <ng-template masterDetailToolbar> -->
    <div class="messages">
    </div>
    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="cancel()">{{'cancel' | translate:
        ['tmc.transport.register.entrance.action.cancel', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button (click)="decline()" [disabled]="isDeclineDisabled()">{{'decline' | translate:
        ['tmc.transport.register.entrance.action.decline', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="onAcceptTabbed()" class="confirm-button"
        [disabled]="isAcceptDisabled()">{{'accept' |
        translate: ['tmc.transport.register.entrance.action.accept', translationService.language]}}</button>
    </sc-actionbar>
    <!-- </ng-template> -->
  </div>
</div>